import React, { Children } from 'react';
import { Star, Shield, CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function TrustHub() {
  return <section className="py-20 md:py-32 px-6 bg-white relative overflow-hidden" data-id="element-579">
      {/* Dynamic background blobs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-580">
        <div className="absolute top-20 -left-20 w-64 h-64 bg-yellow/10 rounded-full blur-3xl" data-id="element-581"></div>
        <div className="absolute bottom-20 -right-20 w-80 h-80 bg-teal/10 rounded-full blur-3xl" data-id="element-582"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-583">
        <div className="text-center mb-16" data-id="element-584">
          <h2 className="text-3xl md:text-5xl font-extrabold text-navy mb-6 tracking-tight" data-id="element-585">
            Real reviews, regulator-rated, family-trusted.
          </h2>
        </div>

        <div className="grid lg:grid-cols-12 gap-12" data-id="element-586">
          {/* Reviews Column */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-7 space-y-8" data-id="element-587">
            <div className="flex flex-wrap gap-6 mb-8" data-id="element-588">
              <div className="bg-white px-8 py-6 rounded-[24px] border-2 border-sand shadow-sm flex-1 min-w-[200px] hover:border-yellow transition-colors" data-id="element-589">
                <div className="flex items-center gap-3 mb-2" data-id="element-590">
                  <span className="font-extrabold text-4xl text-navy" data-id="element-591">4.0</span>
                  <div className="flex text-yellow" data-id="element-592">
                    <Star size={20} className="fill-yellow" data-id="element-593" />
                    <Star size={20} className="fill-yellow" data-id="element-594" />
                    <Star size={20} className="fill-yellow" data-id="element-595" />
                    <Star size={20} className="fill-yellow" data-id="element-596" />
                    <Star size={20} className="text-sand" data-id="element-597" />
                  </div>
                </div>
                <p className="text-sm font-bold text-navy/70 uppercase tracking-wide" data-id="element-598">
                  CareforKids (81 reviews)
                </p>
              </div>
              <div className="bg-white px-8 py-6 rounded-[24px] border-2 border-sand shadow-sm flex-1 min-w-[200px] hover:border-yellow transition-colors" data-id="element-599">
                <div className="flex items-center gap-3 mb-2" data-id="element-600">
                  <span className="font-extrabold text-4xl text-navy" data-id="element-601">4.0</span>
                  <div className="flex text-yellow" data-id="element-602">
                    <Star size={20} className="fill-yellow" data-id="element-603" />
                    <Star size={20} className="fill-yellow" data-id="element-604" />
                    <Star size={20} className="fill-yellow" data-id="element-605" />
                    <Star size={20} className="fill-yellow" data-id="element-606" />
                    <Star size={20} className="text-sand" data-id="element-607" />
                  </div>
                </div>
                <p className="text-sm font-bold text-navy/70 uppercase tracking-wide" data-id="element-608">
                  Google (25 reviews)
                </p>
              </div>
            </div>

            <div className="space-y-6" data-id="element-609">
              {/* Review 1 */}
              <div className="bg-cream p-8 rounded-[24px] border border-sand shadow-sm relative" data-id="element-610">
                <div className="absolute top-8 right-8 text-yellow opacity-20" data-id="element-611">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" data-id="element-612">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-613" />
                  </svg>
                </div>
                <div className="flex text-yellow mb-4" data-id="element-614">
                  <Star size={16} className="fill-yellow" data-id="element-615" />
                  <Star size={16} className="fill-yellow" data-id="element-616" />
                  <Star size={16} className="fill-yellow" data-id="element-617" />
                  <Star size={16} className="fill-yellow" data-id="element-618" />
                  <Star size={16} className="fill-yellow" data-id="element-619" />
                </div>
                <p className="text-navy/90 font-medium text-lg italic mb-6 relative z-10" data-id="element-620">
                  "The educators here are wonderful. My daughter has grown so
                  much in confidence since starting in the toddler room."
                </p>
                <div className="flex items-center gap-3" data-id="element-621">
                  <div className="w-10 h-10 rounded-full bg-coral/20 border-2 border-white shadow-sm flex items-center justify-center text-coral font-bold text-sm shrink-0" data-id="element-622">
                    SM
                  </div>
                  <p className="text-sm font-extrabold text-navy" data-id="element-623">
                    Sarah M.{' '}
                    <span className="font-medium text-navy/60" data-id="element-624">
                      — Parent of 2yo
                    </span>
                  </p>
                </div>
              </div>

              {/* Review 2 */}
              <div className="bg-cream p-8 rounded-[24px] border border-sand shadow-sm relative" data-id="element-625">
                <div className="absolute top-8 right-8 text-yellow opacity-20" data-id="element-626">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" data-id="element-627">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-628" />
                  </svg>
                </div>
                <div className="flex text-yellow mb-4" data-id="element-629">
                  <Star size={16} className="fill-yellow" data-id="element-630" />
                  <Star size={16} className="fill-yellow" data-id="element-631" />
                  <Star size={16} className="fill-yellow" data-id="element-632" />
                  <Star size={16} className="fill-yellow" data-id="element-633" />
                  <Star size={16} className="fill-yellow" data-id="element-634" />
                </div>
                <p className="text-navy/90 font-medium text-lg italic mb-6 relative z-10" data-id="element-635">
                  "Great communication and we love the daily updates. The meals
                  provided are excellent and save us so much time."
                </p>
                <div className="flex items-center gap-3" data-id="element-636">
                  <div className="w-10 h-10 rounded-full bg-blue/20 border-2 border-white shadow-sm flex items-center justify-center text-blue font-bold text-sm shrink-0" data-id="element-637">
                    DT
                  </div>
                  <p className="text-sm font-extrabold text-navy" data-id="element-638">
                    David T.{' '}
                    <span className="font-medium text-navy/60" data-id="element-639">
                      — Parent of 4yo
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Regulator & Safety Column */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="lg:col-span-5 space-y-6" data-id="element-640">
            <div className="bg-teal-light p-8 md:p-10 rounded-[24px] border border-teal/20 shadow-sm" data-id="element-641">
              <div className="flex items-center gap-4 mb-6" data-id="element-642">
                <div className="w-12 h-12 rounded-full bg-teal/20 flex items-center justify-center text-teal" data-id="element-643">
                  <Shield size={24} strokeWidth={2.5} data-id="element-644" />
                </div>
                <h3 className="text-2xl font-extrabold text-navy" data-id="element-645">
                  Regulator Rated
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-646">
                <li className="flex items-start gap-3 text-navy font-medium" data-id="element-647">
                  <CheckCircle size={20} className="text-teal shrink-0 mt-0.5" data-id="element-648" />
                  <span data-id="element-649">ACECQA Meeting NQS rating</span>
                </li>
                <li className="flex items-start gap-3 text-navy font-medium" data-id="element-650">
                  <CheckCircle size={20} className="text-teal shrink-0 mt-0.5" data-id="element-651" />
                  <span data-id="element-652">Last quality assessment: September 2025</span>
                </li>
                <li className="flex items-start gap-3 text-navy font-medium" data-id="element-653">
                  <CheckCircle size={20} className="text-teal shrink-0 mt-0.5" data-id="element-654" />
                  <span data-id="element-655">Service registration: SE-00012345</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-8 md:p-10 rounded-[24px] border-2 border-sand shadow-sm" data-id="element-656">
              <h3 className="text-2xl font-extrabold text-navy mb-6" data-id="element-657">
                Safety Standards
              </h3>
              <ul className="space-y-4" data-id="element-658">
                <li className="flex items-start gap-3 text-navy font-medium" data-id="element-659">
                  <CheckCircle size={20} className="text-blue shrink-0 mt-0.5" data-id="element-660" />
                  <span data-id="element-661">Working With Children Checks (current)</span>
                </li>
                <li className="flex items-start gap-3 text-navy font-medium" data-id="element-662">
                  <CheckCircle size={20} className="text-blue shrink-0 mt-0.5" data-id="element-663" />
                  <span data-id="element-664">National Police Checks (current)</span>
                </li>
                <li className="flex items-start gap-3 text-navy font-medium" data-id="element-665">
                  <CheckCircle size={20} className="text-blue shrink-0 mt-0.5" data-id="element-666" />
                  <span data-id="element-667">Secure sign-in/out via app</span>
                </li>
                <li className="flex items-start gap-3 text-navy font-medium" data-id="element-668">
                  <CheckCircle size={20} className="text-blue shrink-0 mt-0.5" data-id="element-669" />
                  <span data-id="element-670">CCTV monitoring</span>
                </li>
                <li className="flex items-start gap-3 text-navy font-medium" data-id="element-671">
                  <CheckCircle size={20} className="text-blue shrink-0 mt-0.5" data-id="element-672" />
                  <span data-id="element-673">First Aid Officer on-site</span>
                </li>
                <li className="flex items-start gap-3 text-navy font-medium" data-id="element-674">
                  <CheckCircle size={20} className="text-blue shrink-0 mt-0.5" data-id="element-675" />
                  <span data-id="element-676">Illness policy aligned with VIC Dept of Health</span>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}